// Imports
import { useStateValue } from '../../_global/jsx/store';
import { ReactQuestionThreeAnswers } from '../../ReactQuestionThreeAnswers/jsx/component.jsx';
import { ReactQuestionFourAnswers } from '../../ReactQuestionFourAnswers/jsx/component.jsx';

import { dangerousHTML } from 'src/lib/utils.js';
// Binds

// Stateful components

export const ReactRapidQuestionSection = () => {

    const [{ globalText, userData, controlData }, dispatch] = useStateValue();

    
    const getAllRapidQuestions = () => {
        let questions = controlData.currentItem.children;

        if (typeof(questions) !== 'undefined') {

            var allQuestions = controlData.currentItem.children.map((question, idx1) => {              
                if (question.qType === 'threeAnswers') {
                    return <ReactQuestionThreeAnswers key={"question__" + idx1} question={question} />
                } else if (question.qType == 'fourAnswers') {
                    return <ReactQuestionFourAnswers key={"question__" + idx1} question={question} />
                }
            });

            return allQuestions;
            
        }

        return null;
    }

    return (
        <div>

            {getAllRapidQuestions()}
            <hr/>

        </div>
    );
};
